import Sidebar from './Sidebar'
import HeaderBar from './HeaderBar'
import { ReactNode } from 'react'

export default function AppShell({ title, children }:{ title:string; children:ReactNode }){
  return (
    <div className="flex min-h-screen app-bg">
      <Sidebar/>
      <main className="flex-1 relative z-10">
        <HeaderBar title={title}/>
        <div className="p-4 md:p-6 space-y-4">{children}</div>
      </main>
    </div>
  )
}
